import _ from "lodash";
import AbstractEntity from "./abstractEntity";

/*
gameTeamObj properties:
  - id
  - team (id)
  - abbr
  - [score]
  - [result]
 */
class GameTeam extends AbstractEntity {
  /**
   *
   * @param {object} gameTeamObj
   * @param {UserInfo} userInfo
   * @param {Team} team
   */
  constructor(gameTeamObj, userInfo, team) {
    super(gameTeamObj, userInfo);
    this.team = team;

    if (this.hasLoaded()) {
      // todo: improve these
      this.label = !!this.team ? this.team.fullName : "game team";
      this.pathDeps = {};
      this.defaultPathName = "game";
    }
  }

  /**
   *
   * @returns {string}
   */
  getResultTextLg() {
    if (!this.obj.result) return "";

    switch (this.obj.result) {
      case "W":
        return "Won";
      case "L":
        return "Lost";
      case "T":
        return "Tied";
      default:
        throw new Error(
          `GameTeam.getResultTextLg() - ERROR - unknown result: ${this.obj.result}`
        );
    }
  }

  /**
   *
   * @returns {string}
   */
  getResultTextSm() {
    return this.obj.result || "";
  }

  /**
   * @param {boolean} isHome
   * @returns {string|null}
   */
  getScore(isHome) {
    // todo: find out if league season uses decimal scoring or not
    if (!this.obj.score && this.obj.score !== 0) return null;
    if ((this.obj.score === 0 && !isHome) || (this.obj.score === 3 && isHome))
      return null;

    return _.round(this.obj.score, 2).toFixed(2);
  }
}

export default GameTeam;
